export const expenseFr = {
  "Donner un note": "Donner un note",
  "Donner le montant": "Donner le montant",
  "jour": "jour",
  "mois": "mois",
}
